module.exports = __webpack_public_path__ + "static/media/piece6.2adc3d56.png";